export default "__VITE_ASSET__748e4d64__"